<template>
  <div class="stockPage">
    <div class="search" style="height: 1.2rem">
      <div class="cityLine">
        <div class="cityLineLeft">
          <span class="title">{{stockTypeObj.typeNameSimple}}</span>
          <span class="desc">{{stockTypeObj.typeNameCity}}:</span>
          <div class="cityItemBox" v-if="stockTypeObj.state==6">
            <span v-for="(city, index) in cityPointList" :key="index" @click="changeCountryPoint(city)" :class="(searchObj.countryId == city.countryId) ? 'active' : 'spanTag'">
              {{ city.countryName }}
              <i class="el-icon-arrow-right" v-if="index < cityPointList.length - 1"></i>
            </span>
          </div>
          <div class="cityItemBox" v-else>
            <span v-for="(city, index) in cityPointList" :key="index" @click="changeCityPoint(city)" :class="(searchObj.cityId == city.cityId) ? 'active' : 'spanTag'">
              {{ city.cityName }}
              <i class="el-icon-arrow-right" v-if="index < cityPointList.length - 1"></i>
            </span>
          </div>
          <el-button v-if="stockTypeObj.typeNameSimple==='住'" type="text" style="transform: scale(0.65);line-height: 0" @click="goBooking(searchObj,stockTypeObj)">前往Booking>></el-button>
        </div>
        <city-autocomplete :placeholderText="stockTypeObj.state==6?'选择其他国家':'选择其他城市'" :width="'width: 1.25rem;'" 
          :searchType="stockTypeObj.state==6?2:1" :action="false" @handleSelect="handleSelect"
          :obj="searchObj" :idProName="stockTypeObj.state==6?'countryId':'cityId'" @clearData="focusCityPoint"
          :nameProName="stockTypeObj.state==6?'countryName1':'cityName'"></city-autocomplete>
      </div>
      <div class="content-centerBox">
        <slot name="searchDiv"></slot>
      </div>
      <div class="content-centerBox">
        <el-input v-model="searchObj.keyword" size="mini" placeholder="关键字/资源名称" style="width:1.5rem"></el-input>
        <span class="searchBtn" @click="postListData('empty')">搜 索</span>
        <el-checkbox v-model="searchObj.lookSelf" style="margin-right: 0.1rem;">只看自营</el-checkbox>
        <el-radio v-model="searchObj.productType" :label="0" @change="postListData('empty')">全部</el-radio>
        <el-radio v-model="searchObj.productType" :label="1" @change="postListData('empty')">预算</el-radio>
        <el-radio v-model="searchObj.productType" :label="2" @change="postListData('empty')">专属</el-radio>
        <el-radio v-model="searchObj.productType" :label="3" @change="postListData('empty')">常规</el-radio>
      </div>
    </div>
    <div class="content Stock-Contents" :ref="'bottomContainerRef'+stockTypeObj.typeNameEn">
      <slot name="contentDiv"></slot>
      <p class="loading" v-show="loading">
        <i class="el-icon-loading"></i>
      </p>
      <p class="noMore" v-show="isMore">没有更多结果了~</p>
    </div>
  </div>
</template>

<script>
import CityAutocomplete from '../../../common/cityAutocomplete.vue'
import { planHeight } from '../../../../assets/utils/PlanHeight'
export default {
  props:{
    searchObj:{
      type:Object,
      default:()=>{return {}}
    },
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
  },
  components:{CityAutocomplete},
  data(){
    return{
      sercherHeight: '1.2rem',  
      heightStr: '0vh',
      cityPointList:[],
      loading:false,
      isMore:false,
      page:0,
      budget:{},
      planDayObj:null,
      scrollShow:true,
      postTime:null,
    }
  },
  mounted(){
    this.$Bus.$on('checkPlanObj',(data,data1,city)=>{
      this.budget = data1;
      this.planDayObj = data;
      this.searchObj.planId = this.budget.planId
      this.$emit('toBudgetData',this.budget)
      if(data.cityList.length>0){
        this.cityPointList = []
        if(this.stockTypeObj.state===6){
          var countryIds = [...new Set(data.cityList.map(e=>e.countryId))]
          countryIds.forEach(e=>{
            var cityObj = data.cityList.find(ee=>ee.countryId==e)
            this.cityPointList.push(cityObj)
          })
          this.searchObj.date = this.dateFormatYMD(data.planDate,"-")
        }else{
          this.cityPointList = data.cityList
          if(this.stockTypeObj.state===0){
            var endDate=data.planDate
            this.budget.planDayList.forEach((e,index)=>{
              if(e.planDay==this.planDayObj.planDay){
                for(var i=(index+1);i<this.budget.planDayList.length;i++){
                  var ee = this.budget.planDayList[i]
                  if(ee.cityList[ee.cityList.length-1]&&e.cityList[e.cityList.length-1].cityId==ee.cityList[ee.cityList.length-1].cityId){
                    endDate = ee.planDate
                  }else{
                    break
                  }
                }
              }
            })
            this.searchObj.date = [this.dateFormatYMD(data.planDate,"-"),this.dateFormatYMD(new Date(this.dateAddDay(endDate,1)).getTime(),"-")]
          }else if(this.stockTypeObj.state===3){
            this.searchObj.date = [this.dateFormatYMD(data.planDate,"-")+" 09:00",this.dateFormatYMD(data.planDate,"-")+" 19:00"]
          }else{
            this.searchObj.date = this.dateFormatYMD(data.planDate,"-")
          }
        }
      }
      if(city&&this.stockTypeObj.state!=6){
        this.searchObj.cityId = city.cityId
        this.searchObj.cityNameCn = city.cityName
        this.searchObj.cityNameEn = city.cityNameEn
        this.searchObj.countryId = city.countryId
        this.searchObj.countryName = city.countryName
        this.postListData('empty')
      }else{
        this.focusCityPoint()
      }
    })
    var _this=this
    this.$refs['bottomContainerRef'+this.stockTypeObj.typeNameEn].addEventListener("scroll", function (event) {
      if (this.clientHeight + this.scrollTop > this.scrollHeight - 10&&!_this.loading&&!_this.isMore&&_this.scrollShow) {
        _this.scrollShow = false;
        _this.postListData()
        setTimeout(() => {
          _this.scrollShow = true;
        }, 1000);
      }
    });
    planHeight()
  },
  beforeDestroy(){
    this.$Bus.$off("checkPlanObj");
  },
  methods:{
    goBooking(v,b) {
      window.open(`https://www.booking.cn/searchresults.zh-cn.html?ss=${v.cityNameCn}&dest_type=city&checkin=${v.date[0]}&checkout=${v.date[1]}&group_adults=2&no_rooms=1&group_children=0&sb_travel_purpose=leisure`)
    },
    focusCityPoint(){
      this.searchObj.countryName =''
      this.searchObj.cityName = ''
      if(this.cityPointList.length>0){
        var city
        if(this.searchObj.state==6){
          city = this.cityPointList[0]
        }else{
          if(this.searchObj.state===0){
            city = this.cityPointList[this.cityPointList.length-1];
          }else{
            if(this.cityPointList.filter(c=>c.countryName.indexOf('中国')==-1).length>0){//代表是国外的团组
              for(var i=0;i<this.cityPointList.length;i++){
                if(this.cityPointList[i].countryName.indexOf('中国')==-1){
                  city = this.cityPointList[i];
                  break
                }
              }
            }else{
              city = this.cityPointList[0]
            }
          }
          this.searchObj.cityId = city.cityId
          this.searchObj.cityNameCn = city.cityName
          this.searchObj.cityNameEn = city.cityNameEn
        }
        this.searchObj.countryId = city.countryId
      }
      this.postListData('empty')
    },
    handleSelect(item){
      if(this.searchObj.state==6){
        this.searchObj.countryId = item.id
        this.searchObj.countryName = item.countryNameCn
      }else{
        this.searchObj.cityId = item.id
        this.searchObj.countryId = item.countryId
        this.searchObj.cityName = item.cityNameCn
        this.searchObj.cityNameCn = item.cityNameCn
        this.searchObj.cityNameEn = item.cityName
      }
      this.searchObj.keyword=''
      this.postListData('empty')
    },
    changeCityPoint(city){
      this.searchObj.cityId = city.cityId
      this.searchObj.countryId = city.countryId
      this.searchObj.cityNameCn = city.cityName
      this.searchObj.cityNameEn = city.cityNameEn
      this.searchObj.keyword=''
      if(this.searchObj.state==3){
        this.searchObj.endAddressObj = null
        this.searchObj.startAddressObj = null
      }
      this.postListData('empty')
    },
    changeCountryPoint(city){
      this.searchObj.countryId = city.countryId
      this.searchObj.countryName = city.countryName
      this.postListData('empty')
    },
    postListData(type){
      if(!this.loading){
        if(type=='empty'){
          this.page=1;
          this.isMore = false;
        }else{
          this.page++;
        }
        this.$emit("postListData",type)
      }
    },
    sortArr(arr){
      return arr.sort(function (a, b) {
        let x = a.sortType
        let y = b.sortType
        return ((x < y) ? -1 : (x > y) ? 1 : 0)
      })
    },
    getDateList(datelist){
      this.postTime = new Date().getTime()
      datelist.forEach(element => {
        element.stockListResults.forEach(item=>{  
          this.$set(item,'checkNumber',1)//this.budget.useNumber
        })
        if(element.productType==1){
          let keysArr = element.stockListResults.map(item=>item['budgetType'])
          let keys = [...new Set(keysArr)]
          var customList =[]
          keys.forEach(item=>{
            var list = element.stockListResults.filter(i=>i.budgetType==item)
            var price = list[0].priceList[0].price
            var currency=list[0].priceList[0].currency
            customList.push({   
              budgetType:item,
              children:list,
              price:price,
              currency:currency,
              isOpen:false
            })
          })
          this.$set(element,'customList',customList)
          element.sortType=2
        }else if(element.productType==2){
          element.sortType=1
        }else{
          element.sortType=element.productType
        }
        if(element.state==2){
          let keysArr = element.stockListResults.map(item=>item['budgetType'])
          let keys = [...new Set(keysArr)]
          var customList =[]
          keys.forEach(item=>{
            var list = element.stockListResults.filter(i=>i.budgetType==item)
            list.forEach(e=>{
              this.$set(e,'checkNumber',this.budget.useNumber)
            })
            customList.push({   
              budgetType:item,
              children:list,
            })
          })
          if(customList.length>0){
            this.$set(element,'checkTypeName',customList[0].budgetType)
          }
          this.$set(element,'customList',customList)
        }
        this.$set(element,'isOpen',false)
      });
      this.sortArr(datelist)
    }
  }
}
</script>

<style lang="scss" scoped>
.stockPage{
  .search{
    .cityLine{
      display: flex;
      padding-right: 0.1rem;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 0.1rem;
      .title{
        display: inline-block;
        width: 0.35rem;
        height: 0.35rem;
        line-height: 0.35rem;
        text-align: center;
        color: #fff;
        font-weight: bold;
        background: #db4e1a;
      }
      .desc{
        margin-left: 0.2rem;
        margin-right: 0.1rem;
        font-weight: bold;
        font-size: 0.12rem;
      }
      .cityLineLeft{
        display: flex;
        align-items: center;
        .cityItemBox{
          font-size: 0.12rem;
          .active{
            color: #da4e1a;
            font-weight: bold;
          }
          .spanTag{
            cursor: pointer;
          }
        }
      }
    }
    .content-centerBox{
      padding: 0.05rem 0.1rem;
      .searchBtn{
        margin: 0 0.15rem;
        text-shadow: 2px 2px 5px #999;
        color: #f54402;
        font-weight: bold;
        cursor: pointer;
      }
      /deep/ .el-radio{
        margin: 0 0.05rem;
      }
    }
  }
  .content{
    margin-top: 0.05rem;
    overflow-y: auto;
    padding: 0.05rem 0.1rem 0 0.1rem;
    position: absolute;
    top: 1.2rem;
    bottom: 0px;
    width: 100%;
    .loading {
      height: 40px;
      text-align: center;
      font-size: 24px;
    }
    .noMore {
      height: 40px;
      text-align: center;
      font-size: 14px;
      color: #a8a8a8;
      line-height: 40px;
    }
  }
  .content::-webkit-scrollbar {
    display: none;
  }
}
</style>